module.exports = __webpack_public_path__ + "static/media/ideation-image-3.0f6807fb.png";